export default [
  {
    name: "VISIO Design Panel 3.5",
    desc: "Akoestisch absorberend wandpaneel met frame, framedikte 3,5 cm",
    category: "Wandpanelen",
    sku: "DEPA 3.5",
    height: "",
    width: "",
    area: "",
    sabins: [0.2, 0.6, 1, 1.05, 1, 0.9],
    imgUrl:
      "https://www.rivasono.nl/images/Praktijkvoorbeelden_600x338/Akoestisch_wandpaneel_Design_Panel_bij_de_tafel.jpg"
  },
  {
    name: "INVISIO Ceiling Panel kader, wit BxHxD 120x120x4",
    desc: "Akoestisch absorberend plafondpaneel met frame, oppervlak zichtzijde in wit",
    category: "Plafondpanelen",
    sku: "CEPA Kader 120x120 wit",
    height: 1.2,
    width: 1.2,
    area: 1.44,
    sabins: [0.4, 0.84, 0.8, 0.9, 1, 1],
    imgUrl:
      "https://www.rivasono.nl/images/Praktijkvoorbeelden_600x338/akoestische_plafondpanelen_in_een_vergaderruimte.jpg"
  }
];



// WEBPACK FOOTER //
// ./src/mixins/productList.js